import React from "react";
import { components } from "react-select";
import deleteLogo from "../../assets/img/delete.png";
import playLogo from "../../assets/img/play.png";
import pauseLogo from "../../assets/img/pause.png";

const CustomOption = (props) => {
  const { data } = props;
  // console.log(data);
  return (
    <components.Option {...props}>
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          <span>
            {data.status === "Active" ? (
              <span className="text-green-500 text-xl">●</span>
            ) : (
              <span className="text-red-500 text-xl">●</span>
            )}
          </span>
          <span className="text-md">{data.label}</span>
        </div>
        <div className="flex items-center">
          {data.status === "Active" ? (
            <button
              onClick={(e) => {
                e.stopPropagation(); // Prevents the dropdown from closing
                data.onStop(data.id); // Trigger modal for deletion
              }}
              className=" text-white px-2  rounded"
            >
              <img src={pauseLogo} width={20} height={20} />
            </button>
          ) : (
            <button
              onClick={(e) => {
                e.stopPropagation(); // Prevents the dropdown from closing
                data.onStart(data.id); // Trigger modal for deletion
              }}
              className=" text-white px-1 py-1 rounded"
            >
              <img src={playLogo} width={30} height={30} />
            </button>
          )}

          <button
            onClick={(e) => {
              e.stopPropagation(); // Prevents the dropdown from closing
              data.onDelete(data.id); // Trigger modal for deletion
            }}
            className=" text-white px-2 py-1 rounded"
          >
            <img src={deleteLogo} width={20} height={20} />
          </button>
        </div>
      </div>
    </components.Option>
  );
};

export default CustomOption;
